import { render } from "./dikelolaPemda.vue?vue&type=template&id=40aa6aad"
import script from "./dikelolaPemda.vue?vue&type=script&lang=js"
export * from "./dikelolaPemda.vue?vue&type=script&lang=js"

import "./dikelolaPemda.vue?vue&type=style&index=0&id=40aa6aad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__